import { createContext, useContext } from "react";

export type StepUpContextValue = {
  run: <T>(operation: () => Promise<T>) => Promise<T>;
};

export const StepUpContext = createContext<StepUpContextValue | null>(null);

export function useStepUp() {
  const value = useContext(StepUpContext);
  if (!value) throw new Error("useStepUp must be used within StepUpProvider");
  return value;
}
